export default __webpack_public_path__ + "static/media/LEVEL16.64e5be80.png";